/**
 * Checks if a binary flag is enabled in a number.
 * @param num - The original number.
 * @param flag - The binary flag to check.
 * @returns True if the flag is enabled, false otherwise.
 */
export function isFlagEnabled(num: number, flag: number): boolean {
  return (num & flag) !== 0;
}
